import { lightColors } from '@/plugins/colors/base/baseColorsLight'

export const buttonTokensLight = {
  'button-primary-background-default': lightColors.brand['500'],
  'button-primary-background-hover': lightColors.brand['300'],
  'button-primary-background-pressed': lightColors.brand['700'],
  'button-primary-background-loading': lightColors.brand['700'],
  'button-primary-background-disabled': lightColors.gray['50'],
  'button-primary-border-hover': lightColors.brand['300'],
  'button-primary-foreground-default': lightColors.gray.white,
  'button-primary-foreground-hover': lightColors.gray.white,
  'button-primary-foreground-pressed': lightColors.gray.white,
  'button-primary-foreground-loading': lightColors.gray.white,
  'button-primary-foreground-disabled': lightColors.gray['400'],
  'button-secondary-gray-background-default': lightColors.gray['100'],
  'button-secondary-gray-background-hover': lightColors.gray['200'],
  'button-secondary-gray-background-pressed': lightColors.gray['200'],
  'button-secondary-gray-background-loading': lightColors.gray['100'],
  'button-secondary-gray-background-disabled': lightColors.gray['100'],
  'button-secondary-gray-foreground-default': lightColors.gray['900'],
  'button-secondary-gray-foreground-hover': lightColors.gray['900'],
  'button-secondary-gray-foreground-loading': lightColors.gray['900'],
  'button-secondary-gray-foreground-pressed': lightColors.gray['900'],
  'button-secondary-gray-foreground-disabled': lightColors.gray['900'],
  'button-secondary-warning-background-default': lightColors.orange['100'],
  'button-secondary-warning-background-hover': lightColors.orange['200'],
  'button-secondary-warning-background-pressed': lightColors.orange['200'],
  'button-secondary-warning-background-loading': lightColors.orange['100'],
  'button-secondary-warning-background-disabled': lightColors.orange['100'],
  'button-secondary-warning-foreground-default': lightColors.gray['900'],
  'button-secondary-warning-foreground-hover': lightColors.gray['900'],
  'button-secondary-warning-foreground-loading': lightColors.gray['900'],
  'button-secondary-warning-foreground-pressed': lightColors.gray['900'],
  'button-secondary-warning-foreground-disabled': lightColors.gray['900'],
  'button-secondary-error-background-default': lightColors.red['100'],
  'button-secondary-error-background-hover': lightColors.red['200'],
  'button-secondary-error-background-pressed': lightColors.red['200'],
  'button-secondary-error-background-loading': lightColors.red['100'],
  'button-secondary-error-background-disabled': lightColors.red['100'],
  'button-secondary-error-foreground-default': lightColors.gray['900'],
  'button-secondary-error-foreground-hover': lightColors.gray['900'],
  'button-secondary-error-foreground-loading': lightColors.gray['900'],
  'button-secondary-error-foreground-pressed': lightColors.gray['900'],
  'button-secondary-foreground-disabled': lightColors.gray['900'],
  'button-secondary-success-background-default': lightColors.green['100'],
  'button-secondary-success-background-hover': lightColors.green['200'],
  'button-secondary-success-background-pressed': lightColors.green['200'],
  'button-secondary-success-background-loading': lightColors.green['100'],
  'button-secondary-success-background-disabled': lightColors.green['100'],
  'button-secondary-success-foreground-default': lightColors.gray['900'],
  'button-secondary-success-foreground-hover': lightColors.gray['900'],
  'button-secondary-success-foreground-loading': lightColors.gray['900'],
  'button-secondary-success-foreground-pressed': lightColors.gray['900'],
  'button-secondary-success-foreground-disabled': lightColors.gray['900'],
  'button-secondary-info-background-default': lightColors.blue['100'],
  'button-secondary-info-background-hover': lightColors.blue['200'],
  'button-secondary-info-background-pressed': lightColors.blue['200'],
  'button-secondary-info-background-loading': lightColors.blue['200'],
  'button-secondary-info-background-disabled': lightColors.blue['100'],
  'button-secondary-info-foreground-default': lightColors.gray['900'],
  'button-secondary-info-foreground-hover': lightColors.gray['900'],
  'button-secondary-info-foreground-loading': lightColors.gray['900'],
  'button-secondary-info-foreground-pressed': lightColors.gray['900'],
  'button-secondary-info-foreground-disabled': lightColors.gray['900'],
  'secondary-button-tertiary-foreground-default': lightColors.gray['500'],
  'button-tertiary-background-hover': lightColors.brand['50'],
  'button-tertiary-background-pressed': lightColors.brand['100'],
  'button-tertiary-foreground-default': lightColors.brand['500'],
  'button-tertiary-foreground-hover': lightColors.brand['500'],
  'button-tertiary-foreground-pressed': lightColors.brand['700'],
  'button-tertiary-foreground-loading': lightColors.brand['700'],
  'button-tertiary-foreground-disabled': lightColors.gray['400']
}

export default buttonTokensLight
